module.exports = __webpack_public_path__ + "static/media/elevator.b0d9be6b.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/elevator.mp3
// module id = 157
// module chunks = 23